import {
  getAnalyticsSettings,
  getSelectedNetworkActivitySettings,
  getSelectedOnBehalfOfUserId,
  getThreadExtendedActivitySettings,
} from '@ms/yammer-data/dist/domains/analyticsSettings/selectors';
import { ThreadExtendedActivityType } from '@ms/yammer-data/dist/state/types';

import { useSelector } from '../useSelector';

type UseSelectedOnBehalfOfUserId = () => ReturnType<typeof getSelectedOnBehalfOfUserId>;
export const useSelectedOnBehalfOfUserId: UseSelectedOnBehalfOfUserId = () => useSelector(getSelectedOnBehalfOfUserId);

type UseSelectedNetworkActivitySettings = () => ReturnType<typeof getSelectedNetworkActivitySettings>;
export const useSelectedNetworkActivitySettings: UseSelectedNetworkActivitySettings = () =>
  useSelector(getSelectedNetworkActivitySettings);

type UseAnalyticsSettings = () => ReturnType<typeof getAnalyticsSettings>;
export const useAnalyticsSettings: UseAnalyticsSettings = () => useSelector(getAnalyticsSettings);

type UseThreadExtendedActivitySettings = (
  activityType: ThreadExtendedActivityType
) => ReturnType<typeof getThreadExtendedActivitySettings>;
export const useThreadExtendedActivitySettings: UseThreadExtendedActivitySettings = (activityType) =>
  useSelector((state) => getThreadExtendedActivitySettings(state, activityType));
